import React from 'react';
import { Button, Card, Modal } from 'react-bootstrap';
import { BSModal } from '~/components/Bootstrap';
import { DeleteConfirmation } from '~/components/Admin';
import { useAdminService } from '~/services';
import { MaclForm, MaclType } from '../MaclForm/MaclForm';

interface EditMaclModalProps {
    macl: MaclType;
    show: boolean;
    setShow: (x: boolean) => void;
}
export function EditMaclModal({ macl, show, setShow }: EditMaclModalProps) {
    const [confirming, setConfirming] = React.useState(false);
    const [editing, setEditing] = React.useState(false);
    const [removing, setRemoving] = React.useState(false);
    const { removeMacl } = useAdminService();

    /**
     * Removes the given macl
     * @returns {Promise<void>}
     */
    async function handleRemoveMacl() {
        try {
            setRemoving(true);
            await removeMacl(macl.id);
            setShow(false);
        } catch (e) {
            setRemoving(false);
        }
    }

    return (
        <BSModal
            id="macl-info-modal"
            show={show}
            onHide={() => {
                setEditing(false);
                setShow(false);
            }}
            aria-labelledby="edit-macl-title"
        >
            <Modal.Header closeButton>
                <Modal.Title id="edit-macl-title" role="heading" aria-level={1}>
                    {macl.name}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <Card className="mb-2">
                        <Card.Header>
                            {!confirming && !editing && (
                                <>
                                    <Button
                                        onClick={() => setEditing(true)}
                                        variant="primary"
                                        size="sm"
                                        className="pull-right ms-1"
                                    >
                                        Edit
                                    </Button>
                                    <Button
                                        onClick={() => setConfirming(true)}
                                        variant="danger"
                                        size="sm"
                                        className="pull-right"
                                    >
                                        Delete
                                    </Button>
                                </>
                            )}
                            MACL Information
                        </Card.Header>
                        <Card.Body>
                            {!editing ? (
                                <div>
                                    <div>Name: {macl.name}</div>
                                    <div>Members: {`${macl.patients_count}`}</div>
                                    <div>Assigned Users: {macl.users_count}</div>
                                </div>
                            ) : (
                                <MaclForm
                                    id="edit-macl-info"
                                    macl={macl}
                                    onCancel={() => setEditing(false)}
                                    onSuccess={() => {
                                        setShow(false);
                                        setEditing(false);
                                    }}
                                />
                            )}
                        </Card.Body>
                        <DeleteConfirmation
                            handleCancel={() => setConfirming(false)}
                            handleConfirmation={handleRemoveMacl}
                            removing={removing}
                            show={confirming}
                        >
                            <span>Are you sure? This action cannot be undone.</span>
                        </DeleteConfirmation>
                    </Card>
                </div>
            </Modal.Body>
        </BSModal>
    );
}
